import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

export const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-slate-50" style={{ fontFamily: "'IBM Plex Sans', sans-serif" }}>
      <Helmet>
        <title>Kebijakan Privasi — RencanaGuru.com</title>
        <meta name="description" content="Kebijakan privasi RencanaGuru.com tentang pengumpulan dan penggunaan data pengguna platform AI guru Indonesia." />
        <link rel="canonical" href="https://rencanaguru.com/privacy-policy" />
      </Helmet>
      {/* Header */}
      <div className="bg-white border-b border-slate-200 px-6 py-4">
        <div className="max-w-3xl mx-auto flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3">
            <img src="/logo.png" alt="RencanaGuru" className="h-8 w-8 object-contain" />
            <span className="font-bold text-lg text-blue-700" style={{ fontFamily: "'Outfit', sans-serif" }}>
              RencanaGuru<span className="text-yellow-500">.com</span>
            </span>
          </Link>
          <Link to="/login" className="text-sm text-blue-600 hover:underline">Kembali ke Login</Link>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-3xl mx-auto px-6 py-12">
        <h1 className="text-3xl font-bold text-slate-800 mb-2" style={{ fontFamily: "'Outfit', sans-serif" }}>
          Kebijakan Privasi
        </h1>
        <p className="text-sm text-slate-400 mb-10">Terakhir diperbarui: 17 Juni 2026</p>

        <div className="bg-white rounded-2xl shadow-sm border border-slate-100 p-8 space-y-8 text-slate-600 leading-relaxed">

          <section>
            <h2 className="text-lg font-semibold text-slate-800 mb-3">1. Informasi yang Kami Kumpulkan</h2>
            <p>Kami mengumpulkan informasi yang Anda berikan secara langsung saat mendaftar, seperti nama, alamat email, dan nama sekolah. Jika Anda mendaftar melalui Google, kami menerima nama, email, dan foto profil dari akun Google Anda.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-slate-800 mb-3">2. Bagaimana Kami Menggunakan Informasi</h2>
            <ul className="list-disc list-inside space-y-2">
              <li>Menyediakan dan mengelola layanan RencanaGuru.com</li>
              <li>Mengirim notifikasi terkait akun dan layanan</li>
              <li>Meningkatkan kualitas platform berdasarkan penggunaan</li>
              <li>Memproses pembayaran dan transaksi koin</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-slate-800 mb-3">3. Penyimpanan Data</h2>
            <p>Data Anda disimpan secara aman di server MongoDB Atlas dengan enkripsi standar industri. Kami tidak menjual atau membagikan data pribadi Anda kepada pihak ketiga untuk tujuan komersial.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-slate-800 mb-3">4. Dokumen yang Dibuat</h2>
            <p>Dokumen perangkat pembelajaran yang Anda buat (Modul Ajar, KKTP, Promes, dll) disimpan di akun Anda dan hanya dapat diakses oleh Anda. Kami tidak menggunakan konten dokumen Anda untuk tujuan lain tanpa izin.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-slate-800 mb-3">5. Keamanan</h2>
            <p>Kami menerapkan langkah-langkah keamanan teknis dan organisasi yang wajar untuk melindungi data Anda dari akses, pengungkapan, perubahan, atau penghancuran yang tidak sah.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-slate-800 mb-3">6. Hak Anda</h2>
            <p>Anda berhak mengakses, memperbarui, atau menghapus data pribadi Anda kapan saja. Untuk permintaan penghapusan akun, hubungi kami melalui email di bawah ini.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-slate-800 mb-3">7. Kontak</h2>
            <p>Jika Anda memiliki pertanyaan tentang kebijakan privasi ini, silakan hubungi kami di <a href="mailto:support@rencanaguru.com" className="text-blue-600 hover:underline">support@rencanaguru.com</a>.</p>
          </section>

        </div>
      </div>
    </div>
  );
};
